import React from "react";

export default class NoPermission extends React.Component {

    render() {
        return (
            <div>
                <div style={{ display: "flex", marginTop: "100px", backgrondColor: "red", flexDirection: "column", alignItems: "center" }}>
                    <i className="fa fa-exclamation-triangle" style={{ color: "red", fontSize: "5em" }}></i>
                    <p style={{ fontSize: "3em", color: "gray" }}>Not found</p>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/jsx/components/pages/no-permmision.jsx